import {
  ProductMatchingOperator,
  ProductSelectionCondition,
  ProductSortingOrder,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {ProductSelectionStrategyType} from 'common/src/modules/productSelectionStrategies/productSelectionStrategies.types';
import {FeedColumn} from 'common/src/modules/relatedItems/relatedItems.types';

export const DefaultCardOutputs = [
  {id: 1, name: 'Success', type: OutputType.Regular, nodeId: 0},
  {id: 2, name: 'Fallback', type: OutputType.Fallback, nodeId: 0},
];

export const DefaultCardOutputsWithPartialSuccess = [
  {id: 1, name: 'Success', type: OutputType.Regular, nodeId: 0},
  {id: 2, name: 'Partial Success', type: OutputType.PartialSuccess, nodeId: 0},
  {id: 3, name: 'Fallback', type: OutputType.Fallback, nodeId: 0},
];

export const defaultCondition: ProductSelectionCondition = {
  feedColumnSignalKey: '',
  operator: ProductMatchingOperator.Equals,
  signalKey: '',
  feedKey: 0,
};

export const defaultCustomMatchingConfiguration = {
  orderBy: FeedColumn.score,
  conditions: [defaultCondition],
  selectionOrder: ProductSortingOrder.Random,
  contentType: ProductSelectionStrategyType.ProductMatching,
};
